module.exports = __webpack_public_path__ + "static/img/5.81c5be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/5.png
// module id = Ze7U
// module chunks = 0